import { render } from "./remote.vue?vue&type=template&id=c82fc094"
import script from "./remote.vue?vue&type=script&lang=js"
export * from "./remote.vue?vue&type=script&lang=js"

import "./remote.vue?vue&type=style&index=0&id=c82fc094&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__